import React, { useState } from "react";
import { Colors } from "../Constants/colors";
import { Typography } from "@mui/material";
import { FontFamily } from "../Constants/Enums/FontFamily.enums";
import { FontSize } from "../Constants/Enums/Size.enums";

export interface DropdownOptions {
  value: string | number | null;
  text: string;
  category?: string;
  metaData?: object;
}
interface Props {
  showDropdown: boolean;
  onSelect: (value: any) => unknown;
  dropdownOption: Array<DropdownOptions>;
  selectedOption?: DropdownOptions;
}

const DropDownOptions = ({
  showDropdown,
  onSelect,
  dropdownOption,
  selectedOption,
}: Props) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  if (!showDropdown) return null;

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 999,
        top: "calc(100% + 8px)",
        left: 0,
        right: 0,
        width: "100%",
        border: `1px solid ${Colors.LightGrey}`,
        backgroundColor: Colors.White,
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
        borderRadius: "8px",
        overflow: "hidden",
        animation: "slideDown 0.2s ease-out",
        maxHeight: "280px",
        overflowY: "auto",
      }}
    >
      <style>
        {`
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      {dropdownOption.map((option, index) => {
        const isSelected = selectedOption?.value === option.value;
        const isHovered = hoveredIndex === index;

        return (
          <div
            key={`${option.value}-${index}`}
            style={{
              width: "100%",
              padding: "12px 16px",
              borderBottom:
                index !== dropdownOption.length - 1
                  ? `1px solid ${Colors.VeryLightGrey}`
                  : "none",
              backgroundColor: isSelected
                ? `${Colors.TangerineOrange}15`
                : isHovered
                  ? Colors.VeryLightGrey
                  : "transparent",
              cursor: "pointer",
              transition: "all 0.2s ease",
              position: "relative",
            }}
            onClick={() => {
              onSelect(option);
            }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {isSelected && (
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: "4px",
                  backgroundColor: Colors.TangerineOrange,
                }}
              />
            )}
            <Typography
              style={{
                color: isSelected ? Colors.TangerineOrange : Colors.Black,
                fontFamily: FontFamily.POPPINS_REGULAR,
                fontSize: FontSize.F14,
                fontWeight: isSelected ? "600" : "400",
              }}
            >
              {option.text}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default DropDownOptions;
